import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import '../css/common.css';
import '../css/title_bar.css';
import Logo from '../images/IconTransGrn.png';

class TitleBar extends Component {

  constructor(props) {
    super(props);

    this.state = { temp: true }
  }

  onContactClick() {
    this.props.history.push('/contact');
  }

  onBackClick() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div id="title-bar" className="app-header app-hdr-footer-common">
        <img alt="" src={Logo} />
        <div id="title-bar-name">myDineStein</div>
        {
//          this.props.showContact ?
          <span id="title-bar-contact" className="title-bar-button" onClick={ ()=>{this.onContactClick()}}>contact</span>
  //        : null
        }
        {
          this.props.showAcountInfo ?
          <span id="title-bar-account-info" className="title-bar-button">account</span>
          : null
        }
        {
          this.props.showBack ?
          <span id="title-bar-account-info" className="title-bar-button" onClick={ ()=>{this.onBackClick()}}>back</span>
          : null
        }
      </div>
    )
  }

}

export default withRouter(TitleBar);



// WEBPACK FOOTER //
// ./src/components/title_bar.js